import { TrackballControls } from '../../libs/TrackballControls';
import { settingsData, threeJsVariables } from '../../settings';
import { setDisableToZoomButtons } from './zoomControl';
import { dollyOutBounce } from './orbitControls';

export function trackballControlsInit () {
  const control = new TrackballControls(threeJsVariables.perspectiveCamera,threeJsVariables.renderer.domElement);
  control.noRotate = true;
  control.noPan = true;
  control.noZoom = false;
  control.zoomSpeed = 1.5;
  control.dynamicDampingFactor = 0.2;

  control.addEventListener('change', trackballHandler);
  control.addEventListener('end', trackballEndHandler);

  threeJsVariables.trackballControls = control;

  return control;
}

function trackballHandler () {
  setDisableToZoomButtons();
}

function trackballEndHandler () {
  dollyOutBounce();
}